import { type AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';
import {
  DSLFieldCaps,
  DSLResponse,
  DSLSearchRequest,
} from '@/shared/api/opensearch';

const defaultOptions = {};

export class SRMOpenSearchAPI {
  static getSearch(
    index: string,
    payload: DSLSearchRequest,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<DSLResponse>(
      `/opensearch/${index}/search`,
      payload,
      {
        ...defaultOptions,
        ...options,
      },
    );
  }
  static getFieldCaps(index: string, options?: AxiosRequestConfig) {
    return srmInstance.get<DSLFieldCaps>(`/opensearch/${index}/field_caps`, {
      ...defaultOptions,
      params: { fields: '*' },
      ...options,
    });
  }
}